module.exports = __webpack_public_path__ + "img/ic_logo_hb@2x.4aa8e51e.png";